import React, { useEffect, useState } from "react";
import { getDocs, collection, updateDoc, doc } from "firebase/firestore";
import { auth, db } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";

const AdminDashboard = () => {
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();

  // Fetch all orders from Firestore
  const fetchOrders = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "bookings"));
      const ordersArray = querySnapshot.docs.map((doc) => ({
        id: doc.id, // Firestore document ID
        ...doc.data(), // All fields from Firestore
      }));
      setOrders(ordersArray);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  // Update status, pickup date, or time
  const updateOrder = async (orderId, field, value) => {
    try {
      const orderRef = doc(db, "bookings", orderId);
      await updateDoc(orderRef, { [field]: value });
      fetchOrders(); // Refresh orders after update
    } catch (error) {
      console.error("Error updating order:", error);
    }
  };

  // Logout function
  const logout = () => {
    signOut(auth)
      .then(() => navigate("/"))
      .catch((error) => console.error("Logout Error:", error));
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Admin Dashboard</h1>
      <button
        onClick={logout}
        style={{ padding: "10px 20px", marginBottom: "20px", border: "1px solid #9c27b0", color: "#9c27b0", borderRadius: "5px" }}
      >
        LOGOUT
      </button>

      <table style={{ margin: "0 auto", borderCollapse: "collapse", width: "90%" }}>
        <thead>
          <tr>
            <th style={cellStyle}>Order ID</th>
            <th style={cellStyle}>Customer Name</th>
            <th style={cellStyle}>Phone Number</th>
            <th style={cellStyle}>Pickup Date</th>
            <th style={cellStyle}>Pickup Time</th>
            <th style={cellStyle}>Status</th>
          </tr>
        </thead>
        <tbody>
          {orders.length > 0 ? (
            orders.map((order) => (
              <tr key={order.id}>
                <td style={cellStyle}>{order.orderId}</td>
                <td style={cellStyle}>{order.name}</td>
                <td style={cellStyle}>{order.phone}</td>

                {/* Editable Pickup Date */}
                <td style={cellStyle}>
                  <input
                    type="date"
                    value={order.pickupDate ? order.pickupDate.split("T")[0] : ""}
                    onChange={(e) => updateOrder(order.id, "pickupDate", e.target.value)}
                  />
                </td>

                {/* Editable Pickup Time */}
                <td style={cellStyle}>
                <input
                  type="time"
                  value={
                    order.pickupTime
                      ? order.pickupTime.includes("T")
                        ? new Date(order.pickupTime).toISOString().substr(11, 5) // ISO datetime format
                        : order.pickupTime // Direct time string like "16:30"
                      : ""
                  }
                  onChange={(e) => updateOrder(order.id, "pickupTime", e.target.value)}
                />
                </td>

                {/* Editable Status Dropdown */}
                <td style={cellStyle}>
                  <select
                    value={order.status}
                    onChange={(e) => updateOrder(order.id, "status", e.target.value)}
                  >
                    <option value="ordered">Ordered</option>
                    <option value="pickedup">PickedUp</option>
                    <option value="washed">Washed</option>
                    <option value="delivered">Delivered</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" style={{ padding: "20px" }}>No orders found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

// Styling for table cells
const cellStyle = {
  border: "1px solid #ccc",
  padding: "10px",
  textAlign: "center",
};

export default AdminDashboard;
